import { ApplicationState } from '../ApplicationStore';
import { NotificationState } from '../state/NotificationState';
import { combineReducers, Reducer } from 'redux';
import updateAuthData from './authReducers';
import updateFormData from './SearchManager/FormReducers';
import updateResultsData from './SearchManager/ResultsReducers';
import updateRuleData from './SearchManager/RuleReducers';
import updateRuleSearchesForm from './SearchManager/RuleSearchesFormReducers';
import updateRuleSearchesResults from './SearchManager/RuleSearchesResultsReducers';
import updateRuleItemEditForm from './SearchManager/RuleItemEditFormReducers';
import updateDiagnosticsExceptionFormData from './SearchManager/Diagnostics/ExceptionFormReducers';
import updateDiagnosticsExceptionResultsData from './SearchManager/Diagnostics/ExceptionResultsReducers';
import updateShoppingDiagnosticsFormDataLive from './ShoppingDiagnostics/FormReducers';
import updateShoppingDiagnosticsResultsDataLive from './ShoppingDiagnostics/ResultsReducers';
import updateShoppingDiagnosticsFormDataHistorical from './ShoppingDiagnostics/FormReducersHistorical';
import updateShoppingDiagnosticsResultsDataHistorical from './ShoppingDiagnostics/ResultsReducersHistorical';
import updateBookingDiagnosticsFormData from './BookingDiagnostics/FormReducers';
import updateBookingDiagnosticsResultsData from './BookingDiagnostics/ResultsReducers';
import updateBCManagerFormData from './BookingCreateManager/FormReducers';
import updateBCManagerResultsData from './BookingCreateManager/ResultsReducers';
import updateBCManagerRuleData from './BookingCreateManager/RuleReducers';
import updateBCManagerRemarksFormData from './BookingCreateManager/RemarksFormReducers';
import updateBCManagerRemarksResultsData from './BookingCreateManager/RemarksResultsReducers';
import updateBCManagerRemarksRuleData from './BookingCreateManager/RemarksRuleReducers';
import updateRegionsFormData from './Regions/FormReducers';
import updateRegionsResultsData from './Regions/ResultsReducer';
import updateRegionsEditorData from './Regions/EditorReducer';
import updateCountriesFormData from './Countries/FormReducers';
import updateCountriesResultsData from './Countries/ResultsReducer';
import updateCountriesEditorData from './Countries/EditorReducer';
import updateLocationsFormData from './Locations/FormReducers';
import updateLocationsResultsData from './Locations/ResultsReducer';
import updateLocationsEditorData from './Locations/EditorReducer';
import updateStationsFormData from './Stations/FormReducers';
import updateStationsResultsData from './Stations/ResultsReducer';
import updateStationsEditorData from './Stations/EditorReducer';
import updateAirlinesFormData from './Airlines/FormReducers';
import updateAirlinesResultsData from './Airlines/ResultsReducer';
import updateAirlinesEditorData from './Airlines/EditorReducer';
import updateBrandsFormData from './Brands/FormReducers';
import updateBrandsResultsData from './Brands/ResultsReducer';
import updateBrandsEditorData from './Brands/EditorReducer';
import updateMarketsFormData from './Markets/FormReducers';
import updateMarketsResultsData from './Markets/ResultsReducer';
import updateMarketsEditorData from './Markets/EditorReducer';
import updateDistributionChannelsFormData from './DistributionChannels/FormReducers';
import updateDistributionChannelsResultsData from './DistributionChannels/ResultsReducer';
import updateDistributionChannelsEditorData from './DistributionChannels/EditorReducer';
import updateAgenciesFormData from './Agencies/FormReducers';
import updateAgenciesResultsData from './Agencies/ResultsReducer';
import updateAgenciesEditorData from './Agencies/EditorReducer';
import updateAgencyGroupsFormData from './AgencyGroups/FormReducers';
import updateAgencyGroupsResultsData from './AgencyGroups/ResultsReducer';
import updateAgencyGroupsEditorData from './AgencyGroups/EditorReducer';
import updateProviderPreferencesFormData from './ProviderPreferences/FormReducers';
import updateProviderPreferencesResultsData from './ProviderPreferences/ResultsReducer';
import updateProviderPreferencesEditorData from './ProviderPreferences/EditorReducer';
import updateProviderCredentialsFormData from './ProviderCredentials/FormReducers';
import updateProviderCredentialsResultsData from './ProviderCredentials/ResultsReducer';
import updateProviderCredentialsEditorData from './ProviderCredentials/EditorReducer';
import updateProviderCredentialsV2FiltersData from './ProviderCredentialsV2/FiltersReducer';
import updateProviderCredentialsV2TableData from './ProviderCredentialsV2/TableReducer';
import updateProviderCredentialsV2EditorData from './ProviderCredentialsV2/EditorReducer';
import updateIdentityProviderSettingsFormData from './IdentityProviderSettings/FormReducers';
import updateIdentityProviderSettingsResultsData from './IdentityProviderSettings/ResultsReducer';
import updateIdentityProviderSettingsEditorData from './IdentityProviderSettings/EditorReducer';
import updateIdentitySettingsFormData from './IdentitySettings/FormReducers';
import updateIdentitySettingsResultsData from './IdentitySettings/ResultsReducer';
import updateIdentitySettingsEditorData from './IdentitySettings/EditorReducer';
import updateRequests from './requestReducers';
import updateMarkupsFormData from './Markups/FormReducers';
import updateMarkupsResultsData from './Markups/ResultsReducers';
import updateMarkupEditorData from './Markups/MarkupEditorReducers';
import updateTicketTLOFormData from './TicketTLO/FormReducer';
import updateTicketTLOResultsData from './TicketTLO/ResultsReducer';
import updateTicketTLOEditorData from './TicketTLO/EditorReducer';
import updateUserPermissionsFormData from './UserPermissions/FormReducers';
import updateUserPermissionsResultsData from './UserPermissions/ResultsReducer';
import updateUserPermissionsEditorData from './UserPermissions/EditorReducer';
import updateGlobalFiltersFormData from './GlobalFilters/FormReducer';
import updateGlobalFiltersResultsData from './GlobalFilters/ResultsReducer';
import updateGlobalFiltersEditorData from './GlobalFilters/EditorReducer';
import updateActivityLogFormData from './ActivityLog/FormReducer';
import updateActivityLogResultsData from './ActivityLog/ResultsReducer';
import updateActivityLogV2FiltersData from './ActivityLogV2/FiltersReducer';
import updateGeoGroupsFiltersData from './GeoGroups/FiltersReducer';
import updateGeoGroupsTableData from './GeoGroups/TableReducer';
import updateGeoGroupsEditorData from './GeoGroups/EditorReducer';
import updateSupplierTableData from './Supplier/TableReducer';
import updateSupplierEditorData from './Supplier/EditorReducer';
import updateAncillariesMappingFiltersData from './AncillariesMapping/FiltersReducer';
import updateAncillariesMappingEditorData from './AncillariesMapping/EditorReducer';
import updateAncillariesMappingTableData from './AncillariesMapping/TableReducer';
import updateSearchManagerV2FiltersData from './SearchManagerV2/FiltersReducers';
import updateSearchManagerV2TableData from './SearchManagerV2/TableReducer';
import updateSearchManagerV2EditorData from './SearchManagerV2/EditorReducer';
import updateTicketTLOV2FiltersData from './TicketTLOV2/FiltersReducers';
import updateTicketTLOV2TableData from './TicketTLOV2/TableReducer';
import updateTicketTLOV2EditorData from './TicketTLOV2/EditorReducer';
import updateGlobalFiltersV2FiltersData from './GlobalFiltersV2/FiltersReducer';
import updateGlobalFiltersV2TableData from './GlobalFiltersV2/TableReducer';
import updateGlobalFiltersV2EditorData from './GlobalFiltersV2/EditorReducer';
import updateMarkupsV2EditorData from './MarkupsV2/EditorReducer';
import updateMarkupsV2FiltersData from './MarkupsV2/FiltersReducers';
import updateMarkupsV2TableData from './MarkupsV2/TableReducer';
import updateBookingCreateManagerV2FiltersData from './BookingCreateManagerV2/FiltersReducers';
import updateBookingCreateManagerV2TableData from './BookingCreateManagerV2/TableReducer';
import updateBookingCreateManagerV2EditorData from './BookingCreateManagerV2/EditorReducer';
import updateBookingCreateManagerV2RemarksFiltersData from './BookingCreateManagerV2/Remarks/FiltersReducers';
import updateBookingCreateManagerV2RemarksTableData from './BookingCreateManagerV2/Remarks/TableReducer';
import updateBookingCreateManagerV2SSRFiltersData from './BookingCreateManagerV2/SSR/FiltersReducers';
import updateBookingCreateManagerV2SSRTableData from './BookingCreateManagerV2/SSR/TableReducer';
import updateBookingCreateManagerV2SSREditorData from './BookingCreateManagerV2/SSR/EditorReducer';
import updateAncillaryDistributionFiltersData from './AncillaryDistribution/FiltersReducer';
import updateAncillaryDistributionTableData from './AncillaryDistribution/TableReducer';
import updateAncillaryDistributionEditorData from './AncillaryDistribution/EditorReducer';
import updateNotifications from './notificationReducers';
import updateVccCredentialsFiltersData from './VccCredentials/FiltersReducer';
import updateVccCredentialsTableData from './VccCredentials/TableReducer';
import updateVccCredentialsEditorData from './VccCredentials/EditorReducer';
import updateVccCredentialsV2FiltersData from './VccCredentialsV2/FiltersReducer';
import updateVccCredentialsV2TableData from './VccCredentialsV2/TableReducer';
import updateBCMSSRFiltersData from './BookingCreateManager/SSR/FiltersReducer';
import updateBCMSSRTableData from './BookingCreateManager/SSR/TableReducer';
import updateBCMSSREditorData from './BookingCreateManager/SSR/EditorReducer';
import updateRuleSearchesV2Reducer from './SearchManagerV2/RuleSearchesReducer';
import updateRuleSearchesTableV2Reducer from './SearchManagerV2/RuleSearchesTableReducer';
import updateBookingTolerancesFiltersData from './BookingTolerances/FiltersReducer';
import updateBookingTolerancesTableData from './BookingTolerances/TableReducer';
import updateSearchSubRuleEditorData from './SearchManagerV2/SubRuleEditorReducer';
import updateBookingTolerancesEditorData from './BookingTolerances/EditorReducer';
import updateAncillariesManagerFiltersData from './AncillariesManager/FiltersReducer';
import updateAncillariesManagerTableData from './AncillariesManager/TableReducer';
import updateAncillariesManagerEditorData from './AncillariesManager/EditorReducer';
import updateSearchSubRuleBulkEditorData from './SearchManagerV2/SubRuleBulkEditorReducer';
import updateBookingCreateManagerV2RemarksEditorData from './BookingCreateManagerV2/Remarks/EditorReducer';
import updateBusinessData from './BusinessData/BusinessDataReducer';
import getDistributionChannelV2EditorData from './DistributionChannelsV2/EditorReducer';

export const combinedAppReducers: Reducer<ApplicationState> = combineReducers({
  authData: updateAuthData,
  searchManager: combineReducers({
    formData: updateFormData,
    resultsData: updateResultsData,
    ruleData: updateRuleData,
    ruleSearchesFormData: updateRuleSearchesForm,
    ruleSearchesResultsData: updateRuleSearchesResults,
    ruleItemEditFormData: updateRuleItemEditForm,
    diagnosticsExceptionFormData: updateDiagnosticsExceptionFormData,
    diagnosticsExceptionResultsData: updateDiagnosticsExceptionResultsData,
  }),
  searchManagerV2: combineReducers({
    filtersData: updateSearchManagerV2FiltersData,
    tableData: updateSearchManagerV2TableData,
    editorData: updateSearchManagerV2EditorData,
    ruleSearchesData: updateRuleSearchesV2Reducer,
    ruleSearchesTableData: updateRuleSearchesTableV2Reducer,
    subRuleEditorData: updateSearchSubRuleEditorData,
    subRuleBulkEditorData: updateSearchSubRuleBulkEditorData,
  }),
  ticketTLOV2: combineReducers({
    filtersData: updateTicketTLOV2FiltersData,
    tableData: updateTicketTLOV2TableData,
    editorData: updateTicketTLOV2EditorData,
  }),
  globalFiltersV2: combineReducers({
    filtersData: updateGlobalFiltersV2FiltersData,
    tableData: updateGlobalFiltersV2TableData,
    editorData: updateGlobalFiltersV2EditorData,
  }),
  providerCredentialsV2: combineReducers({
    filtersData: updateProviderCredentialsV2FiltersData,
    tableData: updateProviderCredentialsV2TableData,
    editorData: updateProviderCredentialsV2EditorData,
  }),
  bookingCreateManager: combineReducers({
    osisFormData: updateBCManagerFormData,
    osisResultsData: updateBCManagerResultsData,
    osisRuleData: updateBCManagerRuleData,
    remarksFormData: updateBCManagerRemarksFormData,
    remarksResultsData: updateBCManagerRemarksResultsData,
    remarksRuleData: updateBCManagerRemarksRuleData,
  }),
  bookingCreateManagerSSR: combineReducers({
    filtersData: updateBCMSSRFiltersData,
    tableData: updateBCMSSRTableData,
    editorData: updateBCMSSREditorData,
  }),
  bookingCreateManagerV2: combineReducers({
    filtersData: updateBookingCreateManagerV2FiltersData,
    tableData: updateBookingCreateManagerV2TableData,
    editorData: updateBookingCreateManagerV2EditorData,
    remarksFiltersData: updateBookingCreateManagerV2RemarksFiltersData,
    remarksTableData: updateBookingCreateManagerV2RemarksTableData,
    remarksEditorData: updateBookingCreateManagerV2RemarksEditorData,
    ssrFiltersData: updateBookingCreateManagerV2SSRFiltersData,
    ssrTableData: updateBookingCreateManagerV2SSRTableData,
    ssrEditorData: updateBookingCreateManagerV2SSREditorData,
  }),
  businessData: combineReducers({
    regions: combineReducers({
      formData: updateRegionsFormData,
      resultsData: updateRegionsResultsData,
      editorData: updateRegionsEditorData,
    }),
    countries: combineReducers({
      formData: updateCountriesFormData,
      resultsData: updateCountriesResultsData,
      editorData: updateCountriesEditorData,
    }),
    locations: combineReducers({
      formData: updateLocationsFormData,
      resultsData: updateLocationsResultsData,
      editorData: updateLocationsEditorData,
    }),
    stations: combineReducers({
      formData: updateStationsFormData,
      resultsData: updateStationsResultsData,
      editorData: updateStationsEditorData,
    }),
    airlines: combineReducers({
      formData: updateAirlinesFormData,
      resultsData: updateAirlinesResultsData,
      editorData: updateAirlinesEditorData,
    }),
    brands: combineReducers({
      formData: updateBrandsFormData,
      resultsData: updateBrandsResultsData,
      editorData: updateBrandsEditorData,
    }),
    markets: combineReducers({
      formData: updateMarketsFormData,
      resultsData: updateMarketsResultsData,
      editorData: updateMarketsEditorData,
    }),
    distributionChannels: combineReducers({
      formData: updateDistributionChannelsFormData,
      resultsData: updateDistributionChannelsResultsData,
      editorData: updateDistributionChannelsEditorData,
    }),
    agencies: combineReducers({
      formData: updateAgenciesFormData,
      resultsData: updateAgenciesResultsData,
      editorData: updateAgenciesEditorData,
    }),
    agencyGroups: combineReducers({
      formData: updateAgencyGroupsFormData,
      resultsData: updateAgencyGroupsResultsData,
      editorData: updateAgencyGroupsEditorData,
    }),
    geoGroups: combineReducers({
      filtersData: updateGeoGroupsFiltersData,
      tableData: updateGeoGroupsTableData,
      editorData: updateGeoGroupsEditorData,
    }),
  }),
  supplier: combineReducers({
    tableData: updateSupplierTableData,
    editorData: updateSupplierEditorData,
  }),
  markups: combineReducers({
    formData: updateMarkupsFormData,
    resultsData: updateMarkupsResultsData,
    editorData: updateMarkupEditorData,
  }),
  markupsV2: combineReducers({
    editorData: updateMarkupsV2EditorData,
    filtersData: updateMarkupsV2FiltersData,
    tableData: updateMarkupsV2TableData,
  }),
  providerPreferences: combineReducers({
    formData: updateProviderPreferencesFormData,
    resultsData: updateProviderPreferencesResultsData,
    editorData: updateProviderPreferencesEditorData,
  }),
  providerCredentials: combineReducers({
    formData: updateProviderCredentialsFormData,
    resultsData: updateProviderCredentialsResultsData,
    editorData: updateProviderCredentialsEditorData,
  }),
  identityProviderSettings: combineReducers({
    formData: updateIdentityProviderSettingsFormData,
    resultsData: updateIdentityProviderSettingsResultsData,
    editorData: updateIdentityProviderSettingsEditorData,
  }),
  identitySettings: combineReducers({
    formData: updateIdentitySettingsFormData,
    resultsData: updateIdentitySettingsResultsData,
    editorData: updateIdentitySettingsEditorData,
  }),
  ticketTLO: combineReducers({
    formData: updateTicketTLOFormData,
    resultsData: updateTicketTLOResultsData,
    editorData: updateTicketTLOEditorData,
  }),
  shoppingDiagnostics: combineReducers({
    live: combineReducers({
      shoppingDiagnosticsFormData: updateShoppingDiagnosticsFormDataLive,
      shoppingDiagnosticsResultsData: updateShoppingDiagnosticsResultsDataLive,
    }),
    historical: combineReducers({
      shoppingDiagnosticsFormData: updateShoppingDiagnosticsFormDataHistorical,
      shoppingDiagnosticsResultsData: updateShoppingDiagnosticsResultsDataHistorical,
    }),
  }),
  bookingDiagnostics: combineReducers({
    bookingDiagnosticsFormData: updateBookingDiagnosticsFormData,
    bookingDiagnosticsResultsData: updateBookingDiagnosticsResultsData,
  }),
  userPermissions: combineReducers({
    FormData: updateUserPermissionsFormData,
    ResultsData: updateUserPermissionsResultsData,
    EditorData: updateUserPermissionsEditorData,
  }),
  globalFilters: combineReducers({
    FormData: updateGlobalFiltersFormData,
    ResultsData: updateGlobalFiltersResultsData,
    EditorData: updateGlobalFiltersEditorData,
  }),
  activityLog: combineReducers({
    formData: updateActivityLogFormData,
    resultsData: updateActivityLogResultsData,
  }),
  activityLogV2: combineReducers({
    filtersData: updateActivityLogV2FiltersData,
  }),
  ancillariesMapping: combineReducers({
    filtersData: updateAncillariesMappingFiltersData,
    editorData: updateAncillariesMappingEditorData,
    tableData: updateAncillariesMappingTableData,
  }),
  ancillariesManager: combineReducers({
    filtersData: updateAncillariesManagerFiltersData,
    tableData: updateAncillariesManagerTableData,
    editorData: updateAncillariesManagerEditorData,
  }),
  ancillaryDistribution: combineReducers({
    filtersData: updateAncillaryDistributionFiltersData,
    editorData: updateAncillaryDistributionEditorData,
    tableData: updateAncillaryDistributionTableData,
  }),
  vccCredentials: combineReducers({
    filtersData: updateVccCredentialsFiltersData,
    tableData: updateVccCredentialsTableData,
    editorData: updateVccCredentialsEditorData,
  }),
  vccCredentialsV2: combineReducers({
    filtersData: updateVccCredentialsV2FiltersData,
    tableData: updateVccCredentialsV2TableData,
  }),
  bookingTolerances: combineReducers({
    filtersData: updateBookingTolerancesFiltersData,
    tableData: updateBookingTolerancesTableData,
    editorData: updateBookingTolerancesEditorData,
  }),
  businessDataV2: combineReducers({
    data: updateBusinessData,
  }),
  distributionChannelsV2: combineReducers({
    data: getDistributionChannelV2EditorData,
  }),
});

export const combinedNotificationReducers: Reducer<NotificationState> = combineReducers({
  notifications: updateNotifications,
  requestsInProgress: updateRequests,
});
